// extracted by mini-css-extract-plugin
module.exports = {"pill-root":"Pill_pill-root__4iYwW"};